"use client"

import { useRef } from 'react'
import PropTypes from 'prop-types'
import ResourcesSection from '../ResourcesSection/ResourcesSection'
import LevelUpAndTrustSection from '../LevelUpAndTrustSection/LevelUpAndTrustSection'
import { motion, useInView } from 'framer-motion';
import Button from '../global-component/DatasheetButtons';

function VulnerabilityManagement({ blok }) {
    const levelUpRef = useRef(null);


    const handleScrollToLevelUp = () => {
        levelUpRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);
    const ref5 = useRef(null);
    const ref6 = useRef(null);
    const ref7 = useRef(null);

    const isInView1 = useInView(ref1, { once: true, margin: "-100px" });
    const isInView2 = useInView(ref2, { once: true, margin: "-100px" });
    const isInView3 = useInView(ref3, { once: true, margin: "-100px" });
    const isInView4 = useInView(ref4, { once: true, margin: "-100px" });
    const isInView5 = useInView(ref5, { once: true, margin: "-100px" });
    const isInView6 = useInView(ref6, { once: true, margin: "-100px" });
    const isInView7 = useInView(ref7, { once: true, margin: "-100px" });

    const handleDashboardClick = () => {
        window.open(blok?.DatasheetCta?.[0]?.asset?.filename, "_blank");
      };

    return (
        <div className='m-auto bg-asmPageTopBG bg-center bg-cover'>
            {/* <AppBar /> */}
            <div className="relative min-h-[1000px] lg:flex flex-col items-center py-8 m-auto">
                {/* Header Section */}
                <div className=" font-aileron py-20 lg:py-32 text-center font-bold">
                    <h2 className="bg-custom-radial bg-clip-text text-transparent text-[48px] lg:text-[80px] px-6">
                        {blok.titleText1.replace(/\u00A0/g, " ")}
                    </h2>
                    <div className="mt-4 text-[20px] w-[85%] m-auto lg:text-[32px] font-normal">
                        {blok.titleText2}
                    </div>
                    <div className="mt-6 flex justify-center gap-6">
                        <button onClick={handleScrollToLevelUp} className="font-aileron text-[18px] lg:text-[24px] font-normal bg-[#5A27E7] !text-white px-6 py-2 rounded-lg hover:bg-[#483889] lg:w-[255px] lg:h-[64px]">
                            {blok.btnText1}
                        </button>
                    </div>
                </div>

                <div className=''>
                    {/* Main Content Section */}
                    <div ref={ref1} className="flex flex-col lg:flex-row items-center justify-center lg:gap-10 lg:max-w-7xl mx-auto 
                    z-20 lg:mb-40">
                        {/* Left Column (Main Image) */}
                        <div className="lg:w-[40%] w-[90%]">
                            <motion.div
                                initial={{ opacity: 0, x: -100 }}
                                animate={isInView1 ? { opacity: 1, x: 0 } : {}}
                                transition={{ duration: 0.8, delay: 0.2 }}
                                className="flex justify-center items-center m-auto mb-10 lg:mb-0">
                                <img src={blok.mainImage1.filename} />
                            </motion.div>
                        </div>

                        <div className="flex flex-col items-center lg:items-start justify-center flex-1">


                            <h2 className="font-aileron text-[28px] text-center lg:text-start lg:text-[48px] 
                                                        !font-bold bg-custom-radial bg-clip-text 
                                                        text-transparent lg:mb-4  mb-4 px-4 lg:px-0 ">
                                {blok.contentText1}
                            </h2>
                            <p className="font-aileron text-[16px] lg:text-[18px] lg:mb-6 w-[90%] mb-6 mx-auto lg:mx-0 text-center lg:text-start">
                                {blok.contentText2}
                            </p>
                            <p className="font-aileron text-[16px] lg:text-[18px] lg:mb-6 w-[90%] mb-6 mx-auto lg:mx-0 text-center lg:text-start">
                                {blok.contentText3}
                            </p>
                            <div className="flex justify-center items-center lg:justify-start">
                            <Button title={blok?.DatasheetCta?.[0]?.text} onClick={handleDashboardClick} />
                            </div>
                        </div>
                    </div>
                    {/* Main Content Section */}
                    <div ref={ref2} className="lg:flex justify-center max-w-7xl mx-auto z-20">
                        <div className="flex-1 lg:ml-6">

                            {/* Description */}
                            <h2 className="font-aileron text-[28px] text-center lg:text-[48px] !font-bold bg-custom-radial bg-clip-text text-transparent mb-6 lg:mb-4 mt-10 lg:-mt-10 w-[80%] lg:w-[80%] m-auto text-center lg:text-start lg:m-0">
                                {blok.contentText4}
                            </h2>
                            <p className="font-aileron text-[16px] lg:text-[18px] mb-6 lg:mb-6 w-[90%] lg:w-[68%] m-auto lg:m-0 text-center lg:text-start">
                                {blok.contentText5}
                            </p>
                            <p className="font-aileron text-[16px] lg:text-[18px] mb-6 lg:mb-6 w-[90%] lg:w-[68%] m-auto lg:m-0 text-center lg:text-start">
                                {blok.contentText6}

                            </p>
                        </div>
                        <div className="w-full lg:w-auto">
                            <motion.div
                                initial={{ opacity: 0, x: 100 }}
                                animate={isInView2 ? { opacity: 1, x: 0 } : {}}
                                transition={{ duration: 0.8, delay: 0.4 }}
                                className="lg:mt-[-8%] lg:-ml-52 w-[350px] lg:w-[647px] lg:h-[426px] flex justify-center items-center m-auto lg:m-0">
                                <img src={blok.mainImage2.filename} />
                            </motion.div>
                        </div>
                    </div>
                </div>
                <div ref={ref3} className='lg:flex justify-center items-center text-center mt-10 p-2 lg:p-0'>
                    <div className='lg:flex gap-10 justify-center text-start xl:h-[496px] xl:w-[1417px] bg-[#FAF9FE] rounded-[20px] py-14 items-center px-4'>
                        <motion.img initial={{ opacity: 0, x: -100 }}
                            animate={isInView3 ? { opacity: 1, x: 0 } : {}}
                            transition={{ duration: 0.8, delay: 0.4 }} src={blok.contentImage1.filename} className='xl:h-[303px] xl:w-[603px] w-[350px] m-auto lg:m-0' />
                        <div className='xl:w-[40%] w-[90%] text-center m-auto lg:m-0 lg:text-start space-y-10 lg:space-y-0'>
                            <h6 className='font-aileron bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[44px] font-bold m-auto mt-10 lg:mt-0'>{blok.contentText7}</h6>
                            <p className='font-lato text-[16px] lg:text-[18px] mt-0'>{blok.contentText8}</p>
                            <p className='font-lato text-[16px] lg:text-[18px] lg:mt-6'>{blok.contentText9}</p>
                        </div>
                    </div>
                </div>
                <div ref={ref4} className='lg:flex justify-center items-center text-center bg-VMTakeActionBg  w-full xl:h-[565px] lg:mt-10 pb-10 lg:pb-0'>
                    <div className='w-full m-auto max-w-7xl'>
                        <div className="pt-16 pb-6 lg:pb-32 text-center !text-white px-6">
                            <h6 className="font-bold font-aileron text-[28px] lg:text-[42px] mb-10 !text-white">
                                {blok.contentText10}
                            </h6>
                            <div className='max-w-7xl m-auto'>
                                <p className='text-[16px] lg:text-[18px] font-lato !text-white'>
                                    {blok.contentText11}
                                </p>
                                <p className='text-[16px] lg:text-[18px] font-lato mt-6 !text-white'>
                                    {blok.contentText12}
                                </p>
                                <p className='text-[16px] lg:text-[18px] font-lato mt-6 !text-white'>
                                    {blok.contentText13}                                </p>
                            </div>
                        </div>
                    </div>
                    <motion.div
                        initial={{ opacity: 0, y: 100 }}
                        animate={isInView4 ? { opacity: 1, y: 0 } : {}}
                        transition={{ duration: 0.8 }}
                        className='bottom-[-88px] absolute xl:w-[1183px] xl:h-[369px] w-full m-auto -mt-20 lg:m-0 bg-white rounded-[8px] 
                        lg:bottom-[-230px] border-4 border-[#cecadd] '>
                        <div className='flex justify-start border-b-4 border-[#cecadd] 
                        xl:w-[1176px] xl:h-[71px] p-4 rounded-[8px]'><p className='font-lato text-18px font-bold'>Timeline</p></div>
                        <img src={blok.contentImage2.filename} className='xl:w-[1134px] xl:h-[223px] lg:ml-6 lg:mt-12' />
                    </motion.div>
                </div>
            </div>
            <div ref={ref5} className='flex justify-center items-center text-center lg:mt-72 px-2'>
                <div className='flex flex-wrap items-center justify-center lg:text-start bg-[#FAF9FE] rounded-[20px] pt-44 pb-20 lg:py-14 max-w-[1500px] m-auto lg:m-0 gap-10 xl:gap-32 px-4 xl:px-24'>
                    <motion.img
                        initial={{ opacity: 0, x: -100 }}
                        animate={isInView5 ? { opacity: 1, x: 0 } : {}}
                        transition={{ duration: 0.8 }}

                        src={blok.contentImage3.filename} className='flex-1 m-auto lg:m-0 object-contain' />
                    <div className='flex-1'>
                        <h6 className='font-aileron bg-custom-radial bg-clip-text text-transparent text-[20px] lg:text-[44px] font-bold  mb-2 lg:mb-[55px]'>{blok.contentText14}</h6>
                        <p className='font-lato text-[16px] lg:text-[18px] mt-0'>{blok.contentText15}<p className='text-[#5D2AE7] font-bold'>{blok.contentText16}</p>
                            <p className='font-lato text-[16px] lg:text-[18px] mt-6'>{blok.contentText17}</p>
                        </p>
                    </div>
                </div>
            </div>
            <div className='w-full flex justify-center'>
                <div className="lg:py-32 mt-10 lg:mt-0 text-center max-w-7xl">
                    <h2 className="font-aileron bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] m-auto font-bold max-w-[80%]">
                        {blok.contentText18}
                    </h2>
                    <p className='font-lato text-[18px] m-auto mt-6 lg:m-auto px-6'>{blok.contentText19}</p>
                    <div ref={ref6} className='flex justify-center'>
                        <motion.img
                            initial={{ opacity: 0, x: 100 }}
                            animate={isInView6 ? { opacity: 1, x: 0 } : {}}
                            transition={{ duration: 0.8 }}

                            src={blok.contentImage4.filename} className='lg:-mt-40 lg:w-[929px] w-[80%]' />
                    </div>
                    {/* <div className="mt-6 flex justify-center gap-6">
                        <button className="font-lato text-[16px] lg:text-[18px] font-normal bg-[#E56717] !text-white px-6 py-2 rounded-[4px] hover:bg-[#d7691d] lg:w-[395px] lg:h-[64px]">
                            {blok.btnText2}
                        </button>
                    </div> */}
                </div>
            </div>
            <div ref={ref7} className='flex flex-col items-center text-center justify-center mb-10 mt-10 lg:mt-0'>
                <div className='mb-10 w-full max-w-7xl'>
                    <div className='flex justify-center mb-10'>
                        <h4 className='font-aileron bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] px-2 font-bold'>{blok.contentText20}</h4>
                    </div>
                    <div className='grid lg:grid-cols-3 m-auto lg:w-full gap-[50px] px-6 lg:px-0'>
                        <motion.div
                            initial={{ opacity: 0, x: -100 }}
                            animate={isInView7 ? { opacity: 1, x: 0 } : {}}
                            transition={{ duration: 0.8 }}

                            className="relative flex-1 p-[4px] rounded-lg bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50">
                            {/* Inner content div */}
                            <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-start items-center text-center py-6">
                                <img src={blok.contentImage5.filename} className="h-[106px] w-[106px] mb-6" />
                                <p className="font-lato text-[24px] text-[#49378F] font-bold  mb-2">{blok.contentText21}</p>
                                <p className="text-[18px] font-lato w-[80%]">{blok.contentText22}</p>
                            </div>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, y: 100 }}
                            animate={isInView7 ? { opacity: 1, y: 0 } : {}}
                            transition={{ duration: 0.8 }}
                            className="relative flex-1 p-[4px] rounded-lg bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50">
                            {/* Inner content div */}
                            <div


                                className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-start items-center text-center py-6">
                                <img src={blok.contentImage6.filename} className='h-[106px] w-[106px] mb-6' />
                                <p className='font-lato text-[24px] !text-[#49378F] font-bold mb-2' style={{color:"#49378F"}}>{blok.contentText23}</p>
                                <p className='text-[18px] font-lato w-[80%]'>{blok.contentText24}</p>
                            </div>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, x: 100 }}
                            animate={isInView7 ? { opacity: 1, x: 0 } : {}}
                            transition={{ duration: 0.8 }}
                            className="relative flex-1 p-[4px] rounded-lg bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50">
                            {/* Inner content div */}
                            <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-start items-center text-center py-6">
                                <img src={blok.contentImage7.filename} className='h-[106px] w-[106px] mb-6' />
                                <p className='font-lato text-[24px] text-[#49378F] font-bold mb-2  px-[24px]'>{blok.contentText25}</p>
                                <p className='text-[18px] font-lato w-[80%]'>{blok.contentText26}</p>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>

            <div className='bg-[#EFEBFB] lg:min-h-[1500px]'>
                <div className='space-y-6 '>
                    <ResourcesSection
                        calenderIcon={blok.calenderIcon.filename}
                        blok={blok}
                    />
                    <div>
                        <LevelUpAndTrustSection certiReqd={true} blok={blok} levelUpRef={levelUpRef}/>
                    </div>
                </div>
            </div>
        </div>
    )
}
VulnerabilityManagement.propTypes = {
    blok: PropTypes.shape({
        titleText1: PropTypes.string,
        titleText2: PropTypes.string,
        btnText1: PropTypes.string,
        btnText2: PropTypes.string,
        mainImage1: PropTypes.object,
        mainImage2: PropTypes.object,
        contentImage1: PropTypes.object,
        contentImage2: PropTypes.object,
        contentImage3: PropTypes.object,
        contentImage4: PropTypes.object,
        contentImage5: PropTypes.object,
        contentImage6: PropTypes.object,
        contentImage7: PropTypes.object,
        contentText1: PropTypes.string,
        contentText2: PropTypes.string,
        contentText3: PropTypes.string,
        contentText4: PropTypes.string,
        contentText5: PropTypes.string,
        contentText6: PropTypes.string,
        contentText7: PropTypes.string,
        contentText8: PropTypes.string,
        contentText9: PropTypes.string,
        contentText10: PropTypes.string,
        contentText11: PropTypes.string,
        contentText12: PropTypes.string,
        contentText13: PropTypes.string,
        contentText14: PropTypes.string,
        contentText15: PropTypes.string,
        contentText16: PropTypes.string,
        contentText17: PropTypes.string,
        contentText18: PropTypes.string,
        contentText19: PropTypes.string,
        contentText20: PropTypes.string,
        contentText21: PropTypes.string,
        contentText22: PropTypes.string,
        contentText23: PropTypes.string,
        contentText24: PropTypes.string,
        contentText25: PropTypes.string,
        contentText26: PropTypes.string,
        contentText27: PropTypes.string,
        calenderIcon: PropTypes.object,
        resource1Content: PropTypes.string,
        resource2Content: PropTypes.string,
        resource3Content: PropTypes.string,
        resource1Date: PropTypes.string,
        resource2Date: PropTypes.string,
        resource3Date: PropTypes.string,
        resource1Img: PropTypes.object,
        resource2Img: PropTypes.object,
        resource3Img: PropTypes.object,
        resource1Text: PropTypes.string,
        resource2Text: PropTypes.string,
        resource3Text: PropTypes.string,
        resourceUrl1: PropTypes.object,
        resourceUrl2: PropTypes.object,
        resourceUrl3: PropTypes.object
    }).isRequired
};

export default VulnerabilityManagement